// extracted by mini-css-extract-plugin
export default {"switch":"SwitchToPrivate_switch__fPwaV","privateSubsContent":"SwitchToPrivate_privateSubsContent__DZY0f","privatePostsInfo":"SwitchToPrivate_privatePostsInfo__1QYVf"};